
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat pt-24"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/87505c603ef0feae3c12190971600621/adf21343a06e6b3c9ad14cf803c07b67.jfif')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Move · Guide · Mount
          </h1>
          <h2 className="text-2xl md:text-4xl font-semibold text-blue-300 mb-8">
            Professional Relocation & Handyman Services
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-6 leading-relaxed">
            Trusted moving, installation and consultancy services across London and the UK
          </p>
          <p className="text-lg text-gray-300 mb-12 leading-relaxed">
            Over 10 years of experience in professional relocations and home services
          </p>
          <div className="flex justify-center">
            <Button 
              size="lg" 
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 text-xl font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-phone-line mr-3"></i>
              Get Free Quote
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
